<div class="raptor-section" *ngIf="showSection" [ngSwitch]="section.layout">

  <div *ngSwitchCase="'select-car'">
    <!-- <raptor-section-select-car></raptor-section-select-car> -->
  </div>

  <!-- DEFAULT LAYOUT -->
  <div *ngSwitchDefault>
    <open-raptor-section-default [section]="section" [form]="form"></open-raptor-section-default>
  </div>

</div>
